module.exports = __webpack_public_path__ + "static/img/selection_1.2f6877e5.png";